@if (frameworkData$ | async; as framework) {
  <div
    class="rounded-md flex flex-col gap-4 bg-white p-6 border border-navy-50 cursor-pointer hover:border-navy-90"
    [class.opacity-50]="!framework.is_visible"
    (click)="onEditClick()"
  >
    <div class="flex justify-between w-full">
      <div class="flex justify-start items-center gap-4">
        @if (framework.logo_url) {
          <img class="h-10.5" [src]="framework.logo_url | safe: 'url'" />
        } @else {
          @if (icon$ | async; as icon) {
            <svg-icon class="w-9.5 h-9.5" [src]="icon"></svg-icon>
          }
        }

        <div class="text-navy-90 text-3xl font-bold">{{ framework.name }}</div>

        <svg-icon class="w-6 h-6 fill-navy-90" [src]="framework.is_visible ? 'eye_open' : 'eye'"></svg-icon>
      </div>

      <div class="flex justify-center items-center">
        <app-icon-button
          class="edit-button"
          [svgIconPath]="'edit'"
          [type]="'basic'"
          [iconSize]="'small'"
        ></app-icon-button>
      </div>
    </div>

    <div class="text-navy-70 text-base">{{ framework.description }}</div>

    @for (evidence of framework.evidence_files; track evidence.evidence_id) {
      <ng-container *ngTemplateOutlet="evidenceFile; context: { evidence }"></ng-container>
    }
  </div>
}

<ng-template #evidenceFile let-evidence="evidence">
  <div class="px-2.5 py-3 rounded-md border border-navy-50 bg-white flex justify-between">
    <div class="flex gap-2 justify-center items-center">
      <svg-icon class="w-7.5 h-7.5 text-navy-90" [src]="'evidence-dark'"></svg-icon>
      <div class="text-navy-90 text-base font-secondary">{{ evidence.trustcenter_display_name }}</div>
    </div>

    @if (!evidence.is_public) {
      <div class="px-3 flex gap-1 text-navy-60 text-base justify-center items-center select-none">
        <svg-icon class="gray-lock w-5 h-5" [src]="'lock'"></svg-icon>
        {{ buildTranslationKey('fileRequiredAccess') | translate }}
      </div>
    }
  </div>
</ng-template>
